import classNames from 'classnames'

import type { ReactElement, ReactNode } from 'react'

import '../input-common.scss'

interface Props {
  children: ReactNode
  className?: string
  error?: string
}

const InputWrapper = ({ children, className, error }: Props): ReactElement => {
  const componentClasses = classNames('input-component input-container', className)

  const fieldContainerClasses = classNames('field-container', { erroneous: !!error })

  return (
    <div className={componentClasses}>
      <div className={fieldContainerClasses}>{children}</div>
      {error ? <span className="error-message">{error}</span> : null}
    </div>
  )
}

export default InputWrapper
